import { SearchField as CssModulesSearchField, SearchFieldProps } from '@sunwebgroup/uds-ui/fields/search-field'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/search-field' instead.
 */
export default Object.assign(
  styled(CssModulesSearchField)<SearchFieldProps>``,
  { displayName: 'SearchField' },
)
